var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32993 2.16546L9 6.83451L15.6701 2.16546C15.546 1.92019 15.291 1.75 15 1.75H3C2.70903 1.75 2.45397 1.92019 2.32993 2.16546ZM15.75 3.94049L9.4301 8.3644C9.17186 8.5452 8.82814 8.5452 8.5699 8.3644L2.25 3.94049V11.5C2.25 11.9108 2.58921 12.25 3 12.25H15C15.4108 12.25 15.75 11.9108 15.75 11.5V3.94049ZM0.75 2.5C0.75 1.26079 1.76079 0.25 3 0.25H15C16.2392 0.25 17.25 1.26079 17.25 2.5V11.5C17.25 12.7392 16.2392 13.75 15 13.75H3C1.76079 13.75 0.75 12.7392 0.75 11.5V2.5Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail.bca661b6.svg";
export { ForwardRef as ReactComponent };